<template>
  <v-btn @click="download" class="text-capitalize" plain rounded>
    <v-icon class="me-2">{{ icons.mdiDownload }}</v-icon>
    İndir
  </v-btn>
</template>

<script>
// Pinia
import { usePageStore } from "@/stores/pageHeader";

// Utils
import { postData } from "@utils";

// Icons
import { mdiDownload } from "@mdi/js";

export default {
  setup() {
    const pageStore = usePageStore();
    const download = async () => {
      try {
        const data = {
          method: "downloadCashReport",
          startdate: pageStore.dateRange.start,
          enddate: pageStore.dateRange.end,
        };
        const response = await postData(data);
        if (response.error) return;
        window.open(response.file, "_blank");
      } catch (e) {}
    };
    return {
      pageStore,
      download,
      // Icons
      icons: {
        mdiDownload,
      },
    };
  },
};
</script>
